module.exports = __webpack_public_path__ + "static/media/flag-bn.d6529b17.webp";